import { render, staticRenderFns } from "./iframecomp.vue?vue&type=template&id=61bb017f"
import script from "./iframecomp.vue?vue&type=script&lang=js"
export * from "./iframecomp.vue?vue&type=script&lang=js"
import style0 from "./iframecomp.vue?vue&type=style&index=0&id=61bb017f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports